import { FC } from 'react'
import { PrimaryHeading } from '@components/atoms/PrimaryHeading'
import { IUser } from '@/types'
import { CompanyPanel } from '@components/molecules/CompanyPanel'
import { getCompanyLogo, getDateTimeFromUtc } from '@/utils'
import styles from './index.module.scss'

type Props = {
  user: IUser
}

export const UserProfileExperiences: FC<Props> = ({ user }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <PrimaryHeading backgroundText='CAREER' htmlTagType='h2'>
          Career
        </PrimaryHeading>
      </div>
      <div className={styles.content}>
        {user?.experiences.map((exp) => {
          return (
            <div key={exp.id} className={styles.companyPanel}>
              <CompanyPanel
                src={getCompanyLogo(exp.company)}
                alt={exp.company.name}
                href={exp.company.status === 'published' ? `/companies/${exp.company.slug}` : ''}
              >
                <div className={styles.expContent}>
                  <div className={styles.companyName}>{exp.company.name}</div>
                  <div className={styles.expTitle}>
                    {exp.title && <>{exp.title}</>}
                    {exp.title && (exp.startedAt || exp.endedAt) && <>・</>}
                    {(exp.startedAt || exp.endedAt) && (
                      <>
                        {getDateTimeFromUtc(exp.startedAt, 'MMMM YYYY')} -{' '}
                        {getDateTimeFromUtc(exp.endedAt, 'MMMM YYYY')}
                      </>
                    )}
                  </div>
                </div>
              </CompanyPanel>
            </div>
          )
        })}
      </div>
    </div>
  )
}
